import { type SWRResponse } from 'swr';

import type ApiError from '@/helpers/ApiError';
import { type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/workflows/user-workflows/{userWorkflowId}/progress';

export type UserWorkflowProgressApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];

export const useUserWorkflowProgress = (
  params: UserWorkflowProgressApi['params'] | null,
  config?: UseNoodleSwrConfig<UserWorkflowProgressApi['response']>,
): SWRResponse<UserWorkflowProgressApi['response'], ApiError> => {
  const path = params ? buildPath<UserWorkflowProgressApi>(PATH_TEMPLATE, params) : null;
  return useNoodleSwr(path, { revalidateOnFocus: false, ...config });
};

/**
 * @deprecated: Please use `useUserWorkflowProgress` wherever a perfectly fresh response is not worth the network time, bandwidth, and compute.
 */
const getUserWorkflowProgress = async ({
  userWorkflowId,
}: UserWorkflowProgressApi['params']): Promise<UserWorkflowProgressApi['response']> => {
  const path = buildPath<UserWorkflowProgressApi>(PATH_TEMPLATE, { userWorkflowId });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getUserWorkflowProgress;
